import { render, staticRenderFns } from "./governance.vue?vue&type=template&id=6af77744&scoped=true"
import script from "./governance.vue?vue&type=script&lang=js"
export * from "./governance.vue?vue&type=script&lang=js"
import style0 from "./governance.vue?vue&type=style&index=0&id=6af77744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af77744",
  null
  
)

export default component.exports